import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { 
  Header, 
  Icon,
  Breadcrumb
} from "semantic-ui-react";
import {
  SG_FETCH_DEBRIEF_SCHEDULE,
  SG_GET_ORGANIZATION_SELECT
} from "constants/actions";
import BasicErrorMessage from "utilities/ErrorMessages";
import DeepDiveReport from "./DeepDiveReport";

const DeepDiveReportPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [deBriefId, setDebriefId] = useState(null);
  const [debriefDetails, setDebriefDetails] = useState(null);

  function Back() {
    navigate(`/app/brief-schedule/details/${id}`);
  }

  useEffect(() => {
    setDebriefId(id);
  }, [id]);

  useEffect(() => {
    dispatch({
      type: SG_GET_ORGANIZATION_SELECT,
    });
  }, [dispatch]);

  useEffect(() => {
    if (deBriefId) {
      dispatch({
        type: SG_FETCH_DEBRIEF_SCHEDULE,
        payload: { id: deBriefId },
      });
    }
  }, [dispatch, deBriefId]);

  const { get_brief_schedules, get_organization_select } = useSelector(
    (state) => ({
      get_brief_schedules: state.debrief_schedule,
      get_organization_select: state.organizations.organization_select,
    }),
    shallowEqual
  );

  useEffect(() => {
    setDebriefDetails(get_brief_schedules?.[deBriefId]);
  }, [get_brief_schedules, deBriefId]);

  const organizationName = debriefDetails?.organization &&
    get_organization_select.filter(
      (org) => org.id === debriefDetails?.organization
    )?.[0]?.name;

    console.log('Debrief Details:', debriefDetails);
  return (
    <PageContainer>
      <BasicErrorMessage />
      
      <NavigationSection>
        <Breadcrumb>
          <Breadcrumb.Section 
            link 
            onClick={() => navigate('/app/brief-schedule')}
          >
            Brief Schedule
          </Breadcrumb.Section>
          <Breadcrumb.Divider />
          <Breadcrumb.Section 
            link 
            onClick={Back}
          >
            Details #{debriefDetails?.id}
          </Breadcrumb.Section>
          <Breadcrumb.Divider />
          <Breadcrumb.Section active>Deep Dive Report</Breadcrumb.Section>
        </Breadcrumb>
      </NavigationSection>

      <Header as="h1">
        <Icon 
          style={{ cursor: "pointer" }} 
          onClick={Back} 
          name="arrow left" 
        />
        Deep Dive Analysis Report
        <Header.Subheader>
          {debriefDetails?.name} - {organizationName}
          <br />
          {debriefDetails?.type_of_text} {debriefDetails?.survey_type_text}
        </Header.Subheader>
      </Header>

      <SurveyInfoCard>
        <InfoGrid>
          <InfoItem>
            <InfoLabel>Survey ID:</InfoLabel>
            <InfoValue>{debriefDetails?.id}</InfoValue>
          </InfoItem>
          <InfoItem>
            <InfoLabel>Status:</InfoLabel>
            <InfoValue>{debriefDetails?.status_text}</InfoValue>
          </InfoItem>
          <InfoItem>
            <InfoLabel>Total Requests:</InfoLabel>
            <InfoValue>{debriefDetails?.total_requests}</InfoValue>
          </InfoItem>
          <InfoItem>
            <InfoLabel>Total Responses:</InfoLabel>
            <InfoValue>{debriefDetails?.total_responses}</InfoValue>
          </InfoItem>
          <InfoItem>
            <InfoLabel>Response Rate:</InfoLabel>
            <InfoValue>
              {debriefDetails?.total_requests 
                ? Math.round((debriefDetails?.total_responses / debriefDetails?.total_requests) * 100)
                : 0}%
            </InfoValue>
          </InfoItem>
        </InfoGrid>
      </SurveyInfoCard>

      <DeepDiveReport debriefId={deBriefId} />
    </PageContainer>
  );
};

export default DeepDiveReportPage;

// Styled Components
const PageContainer = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
`;

const NavigationSection = styled.div`
  margin-bottom: 20px;
`;

const SurveyInfoCard = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoLabel = styled.span`
  font-weight: bold;
  color: #6c757d;
  font-size: 12px;
  text-transform: uppercase;
  margin-bottom: 4px;
`;

const InfoValue = styled.span`
  font-size: 16px;
  color: #495057;
`;
